import { client } from '../util/sdk';
import { GET, POST, PUT } from '../util/api';

const returnModel = { name: 'PayerNotes' };

export const load = ({ fspId, payerId }, auth) =>
  client.executeRequest(GET, `v2/fsps/${fspId}/payers/${payerId}/payerNotes`, {
    queryParams: { adminUserId: auth.id },
    returnModel,
  });

export const create = ({ fspId, payerId, noteObj }, auth) => {
  if (!fspId || !payerId) {
    throw new Error('fspId and payerId must be defined');
  }

  return client.executeRequest(
    POST,
    `v2/fsps/${fspId}/payers/${payerId}/payerNotes`,
    {
      queryParams: {
        adminUserId: auth.id,
      },
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        note: noteObj.note,
      },
      returnModel,
    }
  );
};

export const loadById = ({ fspId, payerId, noteId }, auth) =>
  client.executeRequest(
    GET,
    `v2/fsps/${fspId}/payers/${payerId}/payerNotes/${noteId}`,
    {
      queryParams: { adminUserId: auth.id },
      returnModel,
    }
  );

export const update = ({ fspId, payerId, id, noteObj }, auth) =>
  client.executeRequest(
    PUT,
    `v2/fsps/${fspId}/payers/${payerId}/payerNotes/${id}`,
    {
      queryParams: { adminUserId: auth.id },
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        note: noteObj.note,
      },
      returnModel,
    }
  );
